import ReviewStatus from '~/components/Structures/ReviewStatus';
import { StructureSetId } from '~/domain/changes/ids';
import { useStructureSetDetailView } from '~/hooks/domain/useStructureSetDetailView';

/** A structure set's approval status, read where it is shown. */
export default function StructureSetReviewStatus({
    id,
}: {
    id?: StructureSetId;
}) {
    const detail = useStructureSetDetailView(id);
    return detail ? (
        <ReviewStatus
            status={detail.approvalStatus}
            fontSize={10}
            color="text.secondary"
        />
    ) : null;
}
